import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TidService } from '../services/tid.service';

@Injectable({
  providedIn: 'root',
})
export class TidAuthGuard implements CanActivate {
  constructor(private tidService: TidService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const code = route.queryParams.code;
    this.tidService.parentUrl = route.queryParams.parentUrl;
    this.tidService.email = route.queryParams.email;
    if (!code) {
      this.tidService.removeAuthCode();
      this.tidService.parentUrl = '';
      this.tidService.email = '';
      this.router.navigate(['/login']);
      return false;
    }

    this.tidService.setAuthCode(code);

    return true;
  }
}
